"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidationTooltip = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Popper = require("../utils/_Popper");
var _Icon = require("../Icon/Icon");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _isInfoIcon = require("../utils/isInfoIcon");
var _ValidationTooltip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationTooltip.css") : void 0);
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
// This linting rule is disabled due to the blur/focus events being present
// inside of the form control which consumes this validation tooltip.
/* eslint-disable jsx-a11y/no-static-element-interactions */
// This linting rule is disabled due to custom handling of focus elements. Since we
// custom handle focus of the tooltip, we choose to use an <i> tag to anchor the element
// as we control the show/hide of the ValidationTooltip from the focus/blur of the associated
// form control
const CSS_BLOCK = 'sapcnqr-validation-tooltip';
const ValidationTooltip = _props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ValidationTooltip, _props)) : _props;
  const {
    id,
    innerContainerProps,
    show: showProp = false,
    state = 'error',
    targetClassName,
    text
  } = props;
  const [show, setShow] = (0, _react.useState)(showProp);
  let tooltipId = (0, _useUniqueId.default)();
  if (id) {
    tooltipId = id;
  }
  (0, _react.useEffect)(() => {
    setShow(showProp);
  }, [showProp]);
  const handleMouseLeave = () => {
    setShow(false);
  };
  const handleMouseEnter = () => {
    setShow(true);
  };
  const getIconName = _react.default.useMemo(() => (0, _isInfoIcon.isInfoIcon)(state) ? state : `messaging-${state}`, [state]);
  const classnames = _bind.default.bind(_ValidationTooltip.default);
  const tooltipClasses = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--in`]: show
  });
  const targetClasses = classnames(`${CSS_BLOCK}__target`, targetClassName);
  const arrowClasses = classnames(`${CSS_BLOCK}__arrow`, `${CSS_BLOCK}__arrow--${state}`);
  const innerClasses = classnames(`${CSS_BLOCK}__inner`, `${CSS_BLOCK}__inner--${state}`, innerContainerProps === null || innerContainerProps === void 0 ? void 0 : innerContainerProps.className);
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: arrowClasses,
    disableEdgeDetection: true,
    popperClassName: tooltipClasses,
    popperPlacement: "top-start",
    popperProps: {
      'aria-live': 'polite',
      id: tooltipId,
      role: 'tooltip'
    },
    show: show,
    showArrow: true,
    targetClassName: targetClasses,
    targetComponent: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      ariaLabel: text,
      iconName: getIconName,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      tabIndex: 0,
      onFocus: () => setShow(true),
      onBlur: () => setShow(false),
      size: "sm-minus"
    })
  }, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, innerContainerProps, {
    className: innerClasses
  }), text));
};
exports.ValidationTooltip = ValidationTooltip;
ValidationTooltip.displayName = 'ValidationTooltip';
var _default = exports.default = ValidationTooltip;